<template>
  <div
    class="modal-overlay"
    :class="{ blurred: isBlurred }"
    ref="refRoot"
    tabindex="0"
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"
  >
    <div class="modal-content" :class="{ 'move-up': props.moveUp }">
      <!-- <header v-if="!hideHeader">
        <h3 class="tit-h6">{{ title }}</h3>

        <div v-if="isVisibleButtonClose" class="close-icon">
          <CloseIcon @click="closeModal" />
        </div>
      </header> -->
      <main>
        <slot></slot>
        <!--모달 내용-->
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

const props = withDefaults(
  defineProps<{
    title?: string;
    isVisibleButtonClose?: boolean;
    isBlurred?: boolean;
    moveUp?: boolean;
    hideHeader?: boolean; // 헤더 제거 타입 추가
  }>(),
  {
    title: '',
    isVisibleButtonClose: true,
    isBlurred: true,
    moveUp: true,
    hideHeader: false,
  }
);
const emit = defineEmits(['close']);

const refRoot = ref<HTMLElement | null>(null);
let mouseDownTarget: EventTarget | null = null;

const onMouseDown = (e: MouseEvent) => {
  mouseDownTarget = e.target;
};

const onMouseUp = (e: MouseEvent) => {
  if (e.target === e.currentTarget && mouseDownTarget === e.currentTarget) {
    closeModal();
  }
};

const closeModal = () => {
  if (props.isVisibleButtonClose) {
    emit('close');
  }
};

onMounted(() => {
  refRoot.value?.focus();
  document.body.style.overflow = 'hidden';
});

onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1501;
}

.modal-overlay.blurred {
  background: var(--surface-glass-dark);
  backdrop-filter: $blur-medium;
}

.modal-content {
  width: 100%;
  max-width: 320px;
  height: fit-content;
  max-height: 90dvh;
  border-radius: 12px;
  background: var(--surface-overlay);
  box-shadow: $shadow-modal;
}

main {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 1.25rem;
  overflow-y: auto;
  max-height: calc(90dvh - 4rem);
  overflow-x: hidden;
}

header {
  display: flex;
  justify-content: space-between;
  padding: 1.25rem;
  .close-icon {
    display: flex;
    cursor: pointer;
    width: 1.5rem;
    height: 1.5rem;
    svg {
      color: var(--font-default);
    }
  }
}

.move-up {
  transition: transform 0.3s ease-in-out;
}
</style>
